import { render, staticRenderFns } from "./UnitNotes.vue?vue&type=template&id=2a980e7c&scoped=true&"
import script from "./UnitNotes.vue?vue&type=script&lang=js&"
export * from "./UnitNotes.vue?vue&type=script&lang=js&"
import style0 from "./UnitNotes.vue?vue&type=style&index=0&id=2a980e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a980e7c",
  null
  
)

export default component.exports